var React = require('react');

function Checkmark (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M10.2533 0.18198C10.058 -0.0132818 9.74142 -0.0132816 9.54616 0.181981L4.24286 5.48528L1.76799 3.01041C1.57273 2.81515 1.25614 2.81515 1.06088 3.01041L0.353775 3.71751C0.158513 3.91278 0.158513 4.22936 0.353775 4.42462L3.1822 7.25305L3.88931 7.96015C4.08457 8.15542 4.40115 8.15542 4.59642 7.96015L5.30352 7.25305L10.9604 1.59619C11.1556 1.40093 11.1556 1.08435 10.9604 0.889087L10.2533 0.18198Z","fill":"currentColor"}));
}

Checkmark.defaultProps = {"width":"12","height":"9","viewBox":"0 0 12 9","fill":"none"};

module.exports = Checkmark;

Checkmark.default = Checkmark;
